module.exports = __webpack_public_path__ + "a83565ecdd0748380297d52aaa887186.svg";